import { ChangeEvent, Fragment, FunctionComponent } from 'react';
import {
    Card,
    CardContent,
    Container,
    Divider,
    TextField,
    Typography,
} from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { TextReplacementBlock } from '@/models/textReplacement';
import { CardListRow } from '@/components/Card/CardListRow';
import { usePostTextReplacementsMutation } from '@/api/v2/textReplacement';
import { MUTATION_CACHE_KEY } from '@/pages/textCustomizations/components/TextReplacementContent';

type TextReplacementsCardProps = {
    textReplacementBlocks: TextReplacementBlock[];
    onSearch: (searchValue: string) => void;
    onInputBlur: (newValue: string, index: number) => void;
    onSave: () => void;
    title: string;
};

export const TextReplacementsCard: FunctionComponent<
    TextReplacementsCardProps
> = ({ textReplacementBlocks, onSearch, onInputBlur, onSave, title }) => {
    const onTextFieldChange = (e: ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        onSearch(value);
    };
    const [, { isLoading }] = usePostTextReplacementsMutation({
        fixedCacheKey: MUTATION_CACHE_KEY,
    });

    return (
        <Container
            sx={{
                ml: 'unset',
            }}
            maxWidth={false}
        >
            <Card
                sx={{
                    width: '100%',
                }}
            >
                <CardContent
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <Typography variant='h6'>{title}</Typography>

                    <LoadingButton
                        sx={{
                            ml: 'auto',
                        }}
                        variant='contained'
                        onClick={onSave}
                        loading={isLoading}
                    >
                        Speichern
                    </LoadingButton>
                </CardContent>
                <Divider
                    sx={{
                        width: '100%',
                    }}
                />

                <CardListRow
                    sx={{
                        py: 4,

                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <TextField
                        sx={{
                            width: '75%',
                        }}
                        onChange={onTextFieldChange}
                        label='Bezeichnungen suchen'
                    />
                </CardListRow>

                <Divider
                    sx={{
                        width: '100%',
                    }}
                />

                {textReplacementBlocks.map((textReplacementBlock, index) => {
                    return (
                        <Fragment key={index}>
                            <CardListRow>
                                <Typography variant='subtitle2'>
                                    {textReplacementBlock.oldText}
                                </Typography>

                                <TextField
                                    sx={{
                                        mt: 4,
                                        ml: 2,
                                        width: '50%',
                                    }}
                                    value={textReplacementBlock.newText || ''}
                                    onChange={(event) => {
                                        const { value } = event.target;

                                        onInputBlur(value, index);
                                    }}
                                />
                            </CardListRow>
                            <Divider
                                sx={{
                                    width: '100%',
                                }}
                            />
                        </Fragment>
                    );
                })}
            </Card>
        </Container>
    );
};
